import React, { useEffect, useState } from "react";
import {
  Box,
  Tabs,
  Tab,
  Typography,
  TextField,
  Grid,
  Button,
  Alert,
  FormControlLabel,
  Checkbox,
  FormHelperText,
  FormControl,
  CircularProgress,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { validateMarketplaceAccount } from "../../../../utils/validation";
import useAlert from "../../../../hooks/useAlert";
import {
  addMarketPlacesAccount,
  getMarketPlaces,
  getMarketPlacesAccounts,
  updateMarketPlacesAccount,
} from "../../../../redux/actions/marketplacesActions";
import { IoMdSave } from "react-icons/io";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import outWardService from "../../../../services/outWardService";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`marketplace-tabpanel-${index}`}
      aria-labelledby={`marketplace-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}
const MARKETPLACE_FIELDS = {
  n11: [
    { id: "ApiKey", label: "Api Key", valueId: "ApiKey", type: "key" },
    { id: "ApiSecret", label: "Api Secret", valueId: "ApiSecret", type: "key" },
    {
      id: "Currency",
      label: "Para birimi",
      valueId: "Currency",
      type: "settings",
      placeholder: "TRY",
    },
    {
      id: "Domestic",
      label: "Ülke İçi",
      valueId: "Domestic",
      type: "settings",
    },
    {
      id: "shipmentTemplate",
      label: "Sevkiyat Şablonu",
      valueId: "shipmentTemplate",
      type: "settings",
    },
    {
      id: "PreparationTime",
      label: "Hazırlık Süresi",
      valueId: "PreparationTime",
      type: "settings",
    },
  ],
  trendyol: [
    {
      id: "SupplierId",
      label: "Supplier ID",
      valueId: "SupplierId",
      type: "key",
    },
    { id: "ApiKey", label: "Api Key", valueId: "ApiKey", type: "key" },
    { id: "ApiSecret", label: "Api Secret", valueId: "ApiSecret", type: "key" },
    {
      id: "CargoCompanyId",
      label: "Kargo Şirketi ",
      valueId: "CargoCompanyId",
      type: "settings",
    },
    {
      id: "PreparationTime",
      label: "Teslimat süresi ",
      valueId: "PreparationTime",
      type: "settings",
    },
  ],
  ciceksepeti: [
    { id: "ApiKey", label: "Api Key", valueId: "ApiKey", type: "key" },
    {
      id: "SupplierId",
      label: "Supplier ID",
      valueId: "SupplierId",
      type: "key",
    },
    {
      id: "DeliveryType",
      label: "Teslimat Türü",
      valueId: "DeliveryType",
      type: "settings",
      impuType: "DeliveryType",
    },
    {
      id: "PreparationTime",
      label: "Hazırlık Süresi",
      valueId: "PreparationTime",
      type: "settings",
      impuType: "dropdown",
    },
  ],
  hepsiburada: [
    {
      id: "MerchantId",
      label: "Merchnat ID",
      valueId: "MerchantId",
      type: "key",
    },
    { id: "Password", label: "Password", valueId: "Password", type: "key" },
    { id: "Weight", label: "Ağırlık", valueId: "Weight", type: "settings" },
  ],
  pttavm: [
    { id: "UserName", label: "UserName", valueId: "UserName", type: "key" },
    { id: "Password", label: "Password", valueId: "Password", type: "key" },
    { id: "Weight", label: "Ağırlık", valueId: "Weight", type: "settings" },
    { id: "Desi", label: "Desi", valueId: "Desi", type: "settings" },
  ],
  pazarama: [
    { id: "UserName", label: "Api Key", valueId: "UserName", type: "key" },
    { id: "Password", label: "Api Secret", valueId: "Password", type: "key" },
    {
      id: "Currency",
      label: "Para Birimi",
      valueId: "Currency",
      type: "settings",
      placeholder: "TRY",
    },
    { id: "Desi", label: "Desi", valueId: "Desi", type: "settings" },
  ],
  ozon: [
    { id: "ClientId", label: "ClientId", valueId: "ClientId", type: "key" },
    { id: "ApiKey", label: "Api Key", valueId: "ApiKey", type: "key" },
    { id: "Depth", label: "Derinlik(mm)", valueId: "Depth", type: "settings" },
    { id: "Weight", label: "Ağırlık(gr)", valueId: "Weight", type: "settings" },
    { id: "Height", label: "Uzunluk(mm)", valueId: "Height", type: "settings" },
    { id: "Width", label: "Genişlik(mm)", valueId: "Width", type: "settings" },
    {
      id: "CurrencyOzon",
      label: "Para birimi",
      valueId: "Currency",
      type: "settings",
    },
  ],
  idefix: [
    {
      id: "SupplierId",
      label: "Supplier ID",
      valueId: "SupplierId",
      type: "key",
    },
    { id: "ApiKey", label: "Api Key", valueId: "ApiKey", type: "key" },
    { id: "ApiSecret", label: "Api Secret", valueId: "ApiSecret", type: "key" },
    {
      id: "CargoCompanyId",
      label: "Kargo Şirketi",
      valueId: "CargoCompanyId",
      type: "settings",
    },
    {
      id: "PreparationTime",
      label: "Hazırlık süresi",
      valueId: "PreparationTime",
      type: "settings",
    },
  ],
  // Etsy'de kayıt için sadece ApiKey, SharedSecret ve ShopId zorunlu. "settings" alanları
  // (kargo/iade/işleme profili vb.) ancak kayıt + Etsy bağlantısından sonra seçilebildiği için
  // optional işaretli; eksiklikleri ürün gönderiminde backend tarafından kontrol ediliyor.
  etsy: [
    { id: "ApiKey", label: "Api Key (Keystring)", valueId: "ApiKey", type: "key" },
    {
      id: "SharedSecret",
      label: "Shared Secret",
      valueId: "SharedSecret",
      type: "key",
    },
    { id: "ShopId", label: "Shop ID", valueId: "ShopId", type: "key" },
    {
      id: "ShippingProfileId",
      label: "Kargo Profili ID",
      valueId: "ShippingProfileId",
      type: "settings",
      optional: true,
      impuType: "EtsyShippingProfile",
    },
    {
      id: "ReturnPolicyId",
      label: "İade Politikası ID",
      valueId: "ReturnPolicyId",
      type: "settings",
      optional: true,
      impuType: "EtsyReturnPolicy",
    },
    {
      id: "ReadinessStateId",
      label: "İşleme Profili (Readiness State)",
      valueId: "ReadinessStateId",
      type: "settings",
      optional: true,
      impuType: "EtsyReadinessState",
    },
    {
      id: "WhoMade",
      label: "Kim Yaptı",
      valueId: "WhoMade",
      type: "settings",
      optional: true,
      impuType: "WhoMade",
    },
    {
      id: "WhenMade",
      label: "Ne Zaman Yapıldı",
      valueId: "WhenMade",
      type: "settings",
      optional: true,
      impuType: "WhenMade",
    },
  ],
  amazon: [
    { id: "Client", label: "Client", valueId: "Client", type: "key" },
    { id: "ApiKey", label: "Api Key", valueId: "ApiKey", type: "key" },
    { id: "Screet", label: "Screet", valueId: "Screet", type: "key" },
  ],
};

const cargoCompanies = [
  { id: "1", name: "Yurtiçi Kargo" },
  { id: "2", name: "MNG Kargo" },
  { id: "3", name: "Aras Kargo" },
  { id: "4", name: "Yurtiçi Kargo Marketplace" },
  { id: "5", name: "Aynı Gün Teslimat" },
  { id: "6", name: "Horoz Kargo Marketplace" },
  { id: "7", name: "Aras Kargo Marketplace" },
  { id: "8", name: "Yurtiçi Kargo International" },
  { id: "9", name: "Sürat Kargo Marketplace" },
  { id: "10", name: "MNG Kargo Marketplace" },
  { id: "11", name: "Trendyol Express" },
  { id: "12", name: "UPS Kargo Marketplace" },
  { id: "15", name: "PTT Kargo International" },
  { id: "17", name: "Trendyol Express Marketplace" },
  { id: "19", name: "PTT Kargo Marketplace" },
  { id: "25", name: "UPS Kargo" },
  { id: "26", name: "MIGROS" },
  { id: "27", name: "PTT" },
  { id: "28", name: "Trendyol Kurye" },
  { id: "30", name: "Borusan Lojistik Marketplace" },
  { id: "31", name: "Surat Kargo" },
  { id: "37", name: "UPS Kargo International" },
];
const PreparationTime = [
  { id: "1", name: "Çiçek Servis" },
  { id: "4", name: "Hediye Kargo Aynı Gün" },
  { id: "5", name: "Hediye Kargo 1-3 Is Gunu" },
  { id: "18", name: "Hediye Kargo 1-2 Is Gunu" },
];
const DeliveryType = [
  { id: "1", name: "Servis Aracı ile gönderim" },
  { id: "2", name: "Kargo ile gönderim" },
  { id: "3", name: "HKargo+Servis Aracı İle Gönderim" },
];

const WhoMade = [
  { id: "i_did", name: "Ben yaptım" },
  { id: "someone_else", name: "Başka biri yaptı" },
  { id: "collective", name: "Bir kolektif/grup yaptı" },
];

// Etsy when_made sabit bir enum bekliyor, serbest metin kabul etmiyor.
const WhenMade = [
  { id: "made_to_order", name: "Sipariş üzerine (made_to_order)" },
  { id: "2020_2023", name: "2020 - 2023" },
  { id: "2010_2019", name: "2010 - 2019" },
  { id: "2004_2009", name: "2004 - 2009" },
  { id: "before_2004", name: "2004'ten önce" },
  { id: "2000_2003", name: "2000 - 2003" },
  { id: "1990s", name: "1990'lar" },
  { id: "1980s", name: "1980'ler" },
  { id: "1970s", name: "1970'ler" },
  { id: "1960s", name: "1960'lar" },
  { id: "1950s", name: "1950'ler" },
  { id: "1940s", name: "1940'lar" },
  { id: "1930s", name: "1930'lar" },
  { id: "1920s", name: "1920'ler" },
  { id: "1910s", name: "1910'lar" },
  { id: "1900s", name: "1900'ler" },
  { id: "1800s", name: "1800'ler" },
  { id: "1700s", name: "1700'ler" },
  { id: "before_1700", name: "1700'den önce" },
];

const Currency = [
  { id: "EUR_BID", name: "EUR_BID" },
  { id: "EUR", name: "Euro" },
  { id: "GBP_BID", name: "GBP_BID" },
  { id: "GBP", name: "British Pound" },
  { id: "USD_BID", name: "USD_BID" },
  { id: "USD", name: "US Dollar" },
  { id: "TL", name: "TRY" },
];

const CurrencyOzon = [
  { id: "EUR_BID", name: "EUR_BID" },
  { id: "EUR", name: "Euro" },
  { id: "GBP_BID", name: "GBP_BID" },
  { id: "GBP", name: "British Pound" },
  { id: "USD_BID", name: "USD_BID" },
  { id: "USD", name: "US Dollar" },
  { id: "TRY", name: "TRY" },
];
const IdefixCargo = [
  { id: "86", name: "Dijital Teslimat" },
  { id: "87", name: "Elden Teslimat" },
  { id: "78", name: "KargomSende" },
  { id: "82", name: "Ceva" },
  { id: "98", name: "Evdemo Lojistik" },
  { id: "97", name: "Mars Lojistik" },
  { id: "96", name: "Kolay Gelsin" },
  { id: "95", name: "Bir günde kargo" },
  { id: "85", name: "Hepsijet XL" },
  { id: "94", name: "Ebebek Standart Kargo" },
  { id: "93", name: "UPS Kargo" },
  { id: "84", name: "Hepsijet" },
  { id: "83", name: "Sendeo" },
  { id: "80", name: "Ptt" },
  { id: "92", name: "Bolt Kargo" },
  { id: "91", name: "Scotty" },
  { id: "90", name: "Kargoist" },
  { id: "89", name: "Jetizz Kargo" },
  { id: "88", name: "Borusan" },
  { id: "79", name: "Aras Kargo" },
  { id: "77", name: "Horoz Lojistik" },
  { id: "76", name: "MNG Kargo" },
  { id: "75", name: "Sürat Kargo" },
  { id: "74", name: "Yurtiçi Kargo" },
];
// const DEFAULT_FIELDS = [
//   { id: 'ApiKey', label: 'Api Key', valueId: 'ApiKey' },
//   { id: 'ApiSecret', label: 'Api Secret', valueId: 'ApiSecret' }
// ];

const MarketplaceForm = ({
  market,
  appUserId,
  formErrors,
  setFormErrors,
  showSuccessMarketPlaceAccountAdd,
  showErrorAlertMarketPlaceAccountAdd,
  showSuccessMarketPlaceAccountUpdate,
  showErrorAlertMarketPlaceAccountUpdate,
  getMarketPlace,
  getMarketpleaceAccounts,
  data,
  token,
  setLoading,
}) => {
  const hasExistingData =
    data &&
    Array.isArray(data) &&
    data.some((item) => item.marketPlaceId === market.id);

  const [formData, setFormData] = useState(() => {
    const initialData = {};
    if (data && Array.isArray(data)) {
      const marketSpecificData = data.filter(
        (item) => item.marketPlaceId === market.id
      );
      marketSpecificData.forEach((item) => {
        const fields =
          MARKETPLACE_FIELDS[market.name.toLowerCase()] || DEFAULT_FIELDS;
        const field = fields.find((f) => f.valueId === item.valueId);
        if (field) {
          initialData[field.id] = item.value;
        }
      });
    }
    console.log(initialData);
    return initialData;
  });

  const handleInputChange = (fieldId, value) => {
    setFormData((prev) => ({
      ...prev,
      [fieldId]: value,
    }));
  };

  const dispatch = useDispatch();

  // Etsy AccessToken artık elle girilmiyor, OAuth akışı sonucunda backend tarafından otomatik
  // yazılıyor; burada sadece bağlı olup olmadığını göstermek için mevcut veriden okunuyor.
  const etsyAccessTokenEntry = data?.find(
    (item) => item.marketPlaceId === market.id && item.valueId === "AccessToken"
  );
  const isEtsyConnected = !!etsyAccessTokenEntry?.value;
  const [etsyConnecting, setEtsyConnecting] = useState(false);
  const [etsyConnectError, setEtsyConnectError] = useState("");

  // Etsy'nin işleme profili (processing profile) zorunluluğu için: mağazanın var olan
  // profillerini listeler, yoksa profil sayfasından yeni bir tane oluşturmaya izin verir.
  const [etsyReadinessStates, setEtsyReadinessStates] = useState([]);
  const [etsyReadinessLoading, setEtsyReadinessLoading] = useState(false);
  const [etsyReadinessError, setEtsyReadinessError] = useState("");
  const [showCreateReadiness, setShowCreateReadiness] = useState(false);
  const [newReadinessState, setNewReadinessState] = useState("ready_to_ship");
  const [newReadinessMinDays, setNewReadinessMinDays] = useState("");
  const [newReadinessMaxDays, setNewReadinessMaxDays] = useState("");
  const [creatingReadiness, setCreatingReadiness] = useState(false);

  const loadEtsyReadinessStates = async () => {
    setEtsyReadinessError("");
    setEtsyReadinessLoading(true);
    try {
      const result = await outWardService.getEtsyReadinessStates(token);
      setEtsyReadinessStates(Array.isArray(result) ? result : []);
    } catch (err) {
      setEtsyReadinessError(
        err?.response?.data || "İşleme profilleri alınırken hata oluştu."
      );
    } finally {
      setEtsyReadinessLoading(false);
    }
  };

  // Kargo Profili ve İade Politikası alanları da aynı şekilde dropdown ile dolduruluyor.
  const [etsyShippingProfiles, setEtsyShippingProfiles] = useState([]);
  const [etsyShippingLoading, setEtsyShippingLoading] = useState(false);
  const [etsyShippingError, setEtsyShippingError] = useState("");
  const [etsyReturnPolicies, setEtsyReturnPolicies] = useState([]);
  const [etsyReturnPolicyLoading, setEtsyReturnPolicyLoading] = useState(false);
  const [etsyReturnPolicyError, setEtsyReturnPolicyError] = useState("");

  const loadEtsyShippingProfiles = async () => {
    setEtsyShippingError("");
    setEtsyShippingLoading(true);
    try {
      const result = await outWardService.getEtsyShippingProfiles(token);
      setEtsyShippingProfiles(Array.isArray(result) ? result : []);
    } catch (err) {
      setEtsyShippingError(
        err?.response?.data || "Kargo profilleri alınırken hata oluştu."
      );
    } finally {
      setEtsyShippingLoading(false);
    }
  };

  const loadEtsyReturnPolicies = async () => {
    setEtsyReturnPolicyError("");
    setEtsyReturnPolicyLoading(true);
    try {
      const result = await outWardService.getEtsyReturnPolicies(token);
      setEtsyReturnPolicies(Array.isArray(result) ? result : []);
    } catch (err) {
      setEtsyReturnPolicyError(
        err?.response?.data || "İade politikaları alınırken hata oluştu."
      );
    } finally {
      setEtsyReturnPolicyLoading(false);
    }
  };

  useEffect(() => {
    if (market.name?.toLowerCase() === "etsy" && isEtsyConnected) {
      loadEtsyReadinessStates();
      loadEtsyShippingProfiles();
      loadEtsyReturnPolicies();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEtsyConnected]);

  const handleCreateReadinessState = async () => {
    setEtsyReadinessError("");
    if (!newReadinessMinDays || !newReadinessMaxDays) {
      setEtsyReadinessError("Min ve max işleme süresi (gün) giriniz.");
      return;
    }
    try {
      setCreatingReadiness(true);
      const created = await outWardService.createEtsyReadinessState(
        {
          readiness_state: newReadinessState,
          min_processing_time: Number(newReadinessMinDays),
          max_processing_time: Number(newReadinessMaxDays),
        },
        token
      );
      if (created?.readiness_state_id) {
        handleInputChange("ReadinessStateId", String(created.readiness_state_id));
        setShowCreateReadiness(false);
        await loadEtsyReadinessStates();
      }
    } catch (err) {
      setEtsyReadinessError(
        err?.response?.data || "İşleme profili oluşturulurken hata oluştu."
      );
    } finally {
      setCreatingReadiness(false);
    }
  };

  const handleConnectEtsy = async () => {
    setEtsyConnectError("");
    if (!formData.ApiKey) {
      setEtsyConnectError("Bağlanmadan önce Api Key bilgisini kaydetmelisiniz.");
      return;
    }
    try {
      setEtsyConnecting(true);
      const result = await outWardService.connectEtsy(token);
      if (result?.url) {
        const popup = window.open(result.url, "_blank", "width=600,height=700");
        // Popup kapandığında (izin verildi/vazgeçildi fark etmeksizin) hesap listesini
        // tazeleyip "Bağlı" durumunu güncelliyoruz.
        const popupCheckInterval = setInterval(() => {
          if (popup?.closed) {
            clearInterval(popupCheckInterval);
            getMarketpleaceAccounts();
          }
        }, 1000);
      } else {
        setEtsyConnectError("Bağlantı linki alınamadı.");
      }
    } catch (err) {
      setEtsyConnectError(
        err?.response?.data || "Bağlantı linki alınırken hata oluştu."
      );
    } finally {
      setEtsyConnecting(false);
    }
  };

  const addMarketAccount = async (event) => {
    event.preventDefault();
    const fields =
      MARKETPLACE_FIELDS[market.name.toLowerCase()] || DEFAULT_FIELDS;
    const marketplaceData = fields.map((field) => ({
      marketplaceId: market.id,
      valueId: field.valueId,
      value: formData[field.id] || "",
      appUserId: appUserId,
      type: field.type,
    }));

    const errors = validateMarketplaceAccount(marketplaceData).map((error, i) =>
      fields[i]?.optional ? {} : error
    );
    setFormErrors(errors);
    const hasErrors = errors.some((error) => Object.keys(error).length > 0);

    if (!hasErrors) {
      try {
        setLoading(true);
        const response = await dispatch(
          addMarketPlacesAccount({ marketplaceData }, token)
        );
        getMarketPlace();
        getMarketpleaceAccounts();
        setLoading(false);
        showSuccessMarketPlaceAccountAdd();
      } catch (err) {
        setLoading(false);
        showErrorAlertMarketPlaceAccountAdd();
        console.log("Market ayarları eklenemedi", err);
      }
    }
  };

  const updateMarketAccount = async (event) => {
    event.preventDefault();

    const fields =
      MARKETPLACE_FIELDS[market.name.toLowerCase()] || DEFAULT_FIELDS;

    const marketplaceData = fields.map((field) => {
      const matchingData = data.find(
        (d) => d.marketPlaceId === market.id && d.valueId === field.valueId
      );

      return {
        id: matchingData?.id,
        marketplaceId: market.id,
        valueId: field.valueId,
        value: formData[field.id] || "",
        appUserId: appUserId,
        type: field.type,
      };
    });

    const errors = validateMarketplaceAccount(marketplaceData).map((error, i) =>
      fields[i]?.optional ? {} : error
    );
    setFormErrors(errors);
    const hasErrors = errors.some((error) => Object.keys(error).length > 0);

    if (!hasErrors) {
      try {
        setLoading(true);
        const response = await dispatch(
          updateMarketPlacesAccount({ marketplaceData }, token)
        );
        showSuccessMarketPlaceAccountUpdate();
        getMarketPlace();
        getMarketpleaceAccounts();
        setLoading(false);
      } catch (err) {
        setLoading(false);
        showErrorAlertMarketPlaceAccountUpdate();
        console.log("Market ayarları güncellenemedi", err);
      }
    }
  };
  const renderFields = () => {
    const fields =
      MARKETPLACE_FIELDS[market.name.toLowerCase()] || DEFAULT_FIELDS;
    const keyFields = fields.filter((field) => field.type === "key");
    const settingsFields = fields.filter((field) => field.type === "settings");

    return (
      <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
        {keyFields.length > 0 && (
          <>
            <Grid item xs={12} style={{ textAlign: "left" }}>
              <Typography
                variant="h6"
                sx={{ fontSize: { xs: "1rem", sm: "1.25rem" } }}
              >
                Bağlantı Ayarları
              </Typography>
            </Grid>
            {keyFields.map((field, index) => (
              <Grid item xs={12} sm={6} md={4} key={field.id}>
                <TextField
                  size="small"
                  fullWidth
                  label={field.label}
                  value={formData[field.id] || ""}
                  onChange={(e) => handleInputChange(field.id, e.target.value)}
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-root": {
                      fontSize: { xs: "0.875rem", sm: "1rem" },
                    },
                  }}
                  error={formErrors?.find(
                    (k) =>
                      k.type == "key" &&
                      k.marketplaceId == market.id &&
                      k.valueId == field?.id
                  )}
                  helperText={
                    formErrors?.find(
                      (k) =>
                        k.type == "key" &&
                        k.marketplaceId == market.id &&
                        k.valueId == field?.id
                    )?.value || ""
                  }
                />
              </Grid>
            ))}
          </>
        )}

        {settingsFields.length > 0 && (
          <>
            <Grid item xs={12} style={{ textAlign: "left" }}>
              <Typography
                variant="h6"
                sx={{ fontSize: { xs: "1rem", sm: "1.25rem" } }}
              >
                Genel Ayarlar
              </Typography>
            </Grid>
            {settingsFields.map((field, index) => (
              <Grid item xs={12} sm={6} md={4} key={field.id}>
                {field.id == "CargoCompanyId" && market.name == "Idefix" ? (
                  <TextField
                    select
                    size="small"
                    fullWidth
                    label={field.label}
                    value={formData[field.id] || ""}
                    onChange={(e) =>
                      handleInputChange(field.id, e.target.value)
                    }
                    variant="outlined"
                    error={formErrors?.find(
                      (k) =>
                        k.type == "settings" &&
                        k.marketplaceId == market.id &&
                        k.valueId == field?.id
                    )}
                    helperText={
                      formErrors?.find(
                        (k) =>
                          k.type == "settings" &&
                          k.marketplaceId == market.id &&
                          k.valueId == field?.id
                      )?.value || ""
                    }
                  >
                    {IdefixCargo.map((x) => (
                      <MenuItem key={x.id} value={x.id}>
                        {x.name}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : field.id === "CargoCompanyId" ? (
                  <TextField
                    select
                    size="small"
                    fullWidth
                    label={field.label}
                    value={formData[field.id] || ""}
                    onChange={(e) =>
                      handleInputChange(field.id, e.target.value)
                    }
                    variant="outlined"
                    error={formErrors?.find(
                      (k) =>
                        k.type == "settings" &&
                        k.marketplaceId == market.id &&
                        k.valueId == field?.id
                    )}
                    helperText={
                      formErrors?.find(
                        (k) =>
                          k.type == "settings" &&
                          k.marketplaceId == market.id &&
                          k.valueId == field?.id
                      )?.value || ""
                    }
                  >
                    {cargoCompanies.map((company) => (
                      <MenuItem key={company.id} value={company.id}>
                        {company.name}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : field.id === "Domestic" ? (
                  <FormControl fullWidth>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formData[field.id] === "true"}
                          onChange={(e) =>
                            handleInputChange(
                              field.id,
                              e.target.checked ? "true" : "false"
                            )
                          }
                          color="primary"
                        />
                      }
                      label={field.label}
                    />
                  </FormControl>
                ) : field.impuType == "dropdown" ? (
                  <TextField
                    select
                    size="small"
                    fullWidth
                    label={field.label}
                    value={formData[field.id] || ""}
                    onChange={(e) =>
                      handleInputChange(field.id, e.target.value)
                    }
                    variant="outlined"
                    error={formErrors?.find(
                      (k) =>
                        k.type == "settings" &&
                        k.marketplaceId == market.id &&
                        k.valueId == field?.id
                    )}
                    helperText={
                      formErrors?.find(
                        (k) =>
                          k.type == "settings" &&
                          k.marketplaceId == market.id &&
                          k.valueId == field?.id
                      )?.value || ""
                    }
                  >
                    {PreparationTime.map((x) => (
                      <MenuItem key={x.id} value={x.id}>
                        {x.name}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : field.impuType == "DeliveryType" ? (
                  <TextField
                    select
                    size="small"
                    fullWidth
                    label={field.label}
                    value={formData[field.id] || ""}
                    onChange={(e) =>
                      handleInputChange(field.id, e.target.value)
                    }
                    variant="outlined"
                    error={formErrors?.find(
                      (k) =>
                        k.type == "settings" &&
                        k.marketplaceId == market.id &&
                        k.valueId == field?.id
                    )}
                    helperText={
                      formErrors?.find(
                        (k) =>
                          k.type == "settings" &&
                          k.marketplaceId == market.id &&
                          k.valueId == field?.id
                      )?.value || ""
                    }
                  >
                    {DeliveryType.map((x) => (
                      <MenuItem key={x.id} value={x.id}>
                        {x.name}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : field.impuType == "WhoMade" ? (
                  <TextField
                    select
                    size="small"
                    fullWidth
                    label={field.label}
                    value={formData[field.id] || ""}
                    onChange={(e) =>
                      handleInputChange(field.id, e.target.value)
                    }
                    variant="outlined"
                    error={formErrors?.find(
                      (k) =>
                        k.type == "settings" &&
                        k.marketplaceId == market.id &&
                        k.valueId == field?.id
                    )}
                    helperText={
                      formErrors?.find(
                        (k) =>
                          k.type == "settings" &&
                          k.marketplaceId == market.id &&
                          k.valueId == field?.id
                      )?.value || ""
                    }
                  >
                    {WhoMade.map((x) => (
                      <MenuItem key={x.id} value={x.id}>
                        {x.name}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : field.impuType == "WhenMade" ? (
                  <TextField
                    select
                    size="small"
                    fullWidth
                    label={field.label}
                    value={formData[field.id] || ""}
                    onChange={(e) =>
                      handleInputChange(field.id, e.target.value)
                    }
                    variant="outlined"
                    error={formErrors?.find(
                      (k) =>
                        k.type == "settings" &&
                        k.marketplaceId == market.id &&
                        k.valueId == field?.id
                    )}
                    helperText={
                      formErrors?.find(
                        (k) =>
                          k.type == "settings" &&
                          k.marketplaceId == market.id &&
                          k.valueId == field?.id
                      )?.value || ""
                    }
                  >
                    {WhenMade.map((x) => (
                      <MenuItem key={x.id} value={x.id}>
                        {x.name}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : field.impuType == "EtsyShippingProfile" ? (
                  <TextField
                    select
                    size="small"
                    fullWidth
                    label={field.label}
                    value={formData[field.id] || ""}
                    onChange={(e) => handleInputChange(field.id, e.target.value)}
                    variant="outlined"
                    disabled={!isEtsyConnected || etsyShippingLoading}
                    error={formErrors?.find(
                      (k) =>
                        k.type == "settings" &&
                        k.marketplaceId == market.id &&
                        k.valueId == field?.id
                    )}
                    helperText={
                      formErrors?.find(
                        (k) =>
                          k.type == "settings" &&
                          k.marketplaceId == market.id &&
                          k.valueId == field?.id
                      )?.value ||
                      etsyShippingError ||
                      (!isEtsyConnected
                        ? "Önce Etsy'e bağlanmalısınız"
                        : etsyShippingLoading
                        ? "Yükleniyor..."
                        : etsyShippingProfiles.length === 0
                        ? "Etsy'de kayıtlı kargo profili bulunamadı"
                        : "")
                    }
                  >
                    {etsyShippingProfiles.map((x) => (
                      <MenuItem key={x.shipping_profile_id} value={String(x.shipping_profile_id)}>
                        {x.title}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : field.impuType == "EtsyReturnPolicy" ? (
                  <TextField
                    select
                    size="small"
                    fullWidth
                    label={field.label}
                    value={formData[field.id] || ""}
                    onChange={(e) => handleInputChange(field.id, e.target.value)}
                    variant="outlined"
                    disabled={!isEtsyConnected || etsyReturnPolicyLoading}
                    error={formErrors?.find(
                      (k) =>
                        k.type == "settings" &&
                        k.marketplaceId == market.id &&
                        k.valueId == field?.id
                    )}
                    helperText={
                      formErrors?.find(
                        (k) =>
                          k.type == "settings" &&
                          k.marketplaceId == market.id &&
                          k.valueId == field?.id
                      )?.value ||
                      etsyReturnPolicyError ||
                      (!isEtsyConnected
                        ? "Önce Etsy'e bağlanmalısınız"
                        : etsyReturnPolicyLoading
                        ? "Yükleniyor..."
                        : etsyReturnPolicies.length === 0
                        ? "Etsy'de kayıtlı iade politikası bulunamadı"
                        : "")
                    }
                  >
                    {etsyReturnPolicies.map((x) => (
                      <MenuItem key={x.return_policy_id} value={String(x.return_policy_id)}>
                        {x.accepts_returns ? "İade" : ""}
                        {x.accepts_returns && x.accepts_exchanges ? " + " : ""}
                        {x.accepts_exchanges ? "Değişim" : ""}
                        {x.return_deadline ? ` (${x.return_deadline} gün)` : ""}
                        {" - #" + x.return_policy_id}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : field.impuType == "EtsyReadinessState" ? (
                  <Box>
                    <TextField
                      select
                      size="small"
                      fullWidth
                      label={field.label}
                      value={formData[field.id] || ""}
                      onChange={(e) =>
                        handleInputChange(field.id, e.target.value)
                      }
                      variant="outlined"
                      disabled={!isEtsyConnected || etsyReadinessLoading}
                      error={formErrors?.find(
                        (k) =>
                          k.type == "settings" &&
                          k.marketplaceId == market.id &&
                          k.valueId == field?.id
                      )}
                      helperText={
                        formErrors?.find(
                          (k) =>
                            k.type == "settings" &&
                            k.marketplaceId == market.id &&
                            k.valueId == field?.id
                        )?.value ||
                        (!isEtsyConnected
                          ? "Önce Etsy'e bağlanmalısınız"
                          : etsyReadinessLoading
                          ? "Yükleniyor..."
                          : etsyReadinessStates.length === 0
                          ? "Hiç işleme profili yok, aşağıdan oluşturabilirsiniz"
                          : "")
                      }
                    >
                      {etsyReadinessStates.map((x) => (
                        <MenuItem key={x.readiness_state_id} value={String(x.readiness_state_id)}>
                          {x.readiness_state}
                          {x.min_processing_time && x.max_processing_time
                            ? ` (${x.min_processing_time}-${x.max_processing_time} gün)`
                            : ""}
                        </MenuItem>
                      ))}
                    </TextField>
                    {etsyReadinessError && (
                      <Typography color="error" variant="caption" sx={{ display: "block", mt: 0.5 }}>
                        {etsyReadinessError}
                      </Typography>
                    )}
                    {isEtsyConnected && (
                      <Button
                        size="small"
                        sx={{ mt: 0.5, textTransform: "none" }}
                        onClick={() => setShowCreateReadiness((prev) => !prev)}
                      >
                        {showCreateReadiness ? "Vazgeç" : "+ Yeni işleme profili oluştur"}
                      </Button>
                    )}
                    {showCreateReadiness && (
                      <Box
                        sx={{
                          mt: 1,
                          p: 1.5,
                          border: "1px solid",
                          borderColor: "divider",
                          borderRadius: 1,
                          display: "flex",
                          flexDirection: "column",
                          gap: 1.25,
                        }}
                      >
                        <TextField
                          select
                          size="small"
                          fullWidth
                          label="Durum"
                          value={newReadinessState}
                          onChange={(e) => setNewReadinessState(e.target.value)}
                        >
                          <MenuItem value="ready_to_ship">Hazır (ready_to_ship)</MenuItem>
                          <MenuItem value="made_to_order">Sipariş Üzerine (made_to_order)</MenuItem>
                        </TextField>
                        <Box sx={{ display: "flex", gap: 1.25 }}>
                          <TextField
                            size="small"
                            fullWidth
                            type="number"
                            label="Min gün"
                            value={newReadinessMinDays}
                            onChange={(e) => setNewReadinessMinDays(e.target.value)}
                          />
                          <TextField
                            size="small"
                            fullWidth
                            type="number"
                            label="Max gün"
                            value={newReadinessMaxDays}
                            onChange={(e) => setNewReadinessMaxDays(e.target.value)}
                          />
                        </Box>
                        <Button
                          fullWidth
                          variant="outlined"
                          size="small"
                          disabled={creatingReadiness}
                          onClick={handleCreateReadinessState}
                        >
                          {creatingReadiness ? "Oluşturuluyor..." : "Oluştur"}
                        </Button>
                      </Box>
                    )}
                  </Box>
                ) : field.id == "Currency" ? (
                  <TextField
                    select
                    size="small"
                    fullWidth
                    label={field.label}
                    value={formData[field.id] || ""}
                    onChange={(e) =>
                      handleInputChange(field.id, e.target.value)
                    }
                    variant="outlined"
                    error={formErrors?.find(
                      (k) =>
                        k.type == "settings" &&
                        k.marketplaceId == market.id &&
                        k.valueId == field?.id
                    )}
                    helperText={
                      formErrors?.find(
                        (k) =>
                          k.type == "settings" &&
                          k.marketplaceId == market.id &&
                          k.valueId == field?.id
                      )?.value || ""
                    }
                  >
                    {Currency.map((x) => (
                      <MenuItem key={x.id} value={x.id}>
                        {x.name}
                      </MenuItem>
                    ))}
                  </TextField>
                ) : (
                  <TextField
                    size="small"
                    fullWidth
                    label={field.label}
                    value={formData[field.id] || ""}
                    placeholder={field?.placeholder}
                    onChange={(e) =>
                      handleInputChange(field.id, e.target.value)
                    }
                    variant="outlined"
                    error={formErrors?.find(
                      (k) =>
                        k.type == "settings" &&
                        k.marketplaceId == market.id &&
                        k.valueId == field?.id
                    )}
                    helperText={
                      formErrors?.find(
                        (k) =>
                          k.type == "settings" &&
                          k.marketplaceId == market.id &&
                          k.valueId == field?.id
                      )?.value || ""
                    }
                  />
                )}
              </Grid>
            ))}
            {market.name == "Trendyol" ? (
              <Grid item xs={12}>
                <Alert
                  severity="info"
                  sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}
                >
                  Trendyol paneli sağ üst profil kısmından Hesap bilgileri
                  sekmesinden -> Entegrasyon bilgileri kısmından api
                  bilgilerinizi alabilirsiniz.
                </Alert>
              </Grid>
            ) : null}
            {market.name == "Hepsiburada" ? (
              <Grid item xs={12}>
                <Alert
                  severity="info"
                  sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}
                >
                  Sağ üstte ki profilden bilgilerim seçilerek açılan sayfada
                  entegrasyon kısmından entegratör ekleyebilirsiniz entegratör
                  kullanıcı adı olarak pazaryericonverter_dev seçmelisiniz.
                </Alert>
              </Grid>
            ) : null}
            {market.name == "N11" ? (
              <Grid item xs={12}>
                <Alert
                  severity="info"
                  sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}
                >
                  Sağ üst hesabım kısmından api hesaplarını seçin açılan sayfada
                  yeni hesap oluşturun API anahtarını kopyalayın ve yeni api
                  şifresi oluşturarak bilgilerinizi edinebilirsiniz.
                </Alert>
              </Grid>
            ) : null}
            {market.name == "Ciceksepeti" ? (
              <Grid item xs={12}>
                <Alert
                  severity="info"
                  sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}
                >
                  Hesap yönetimi sayfasından Entegrasyon bilgilerim kısmına
                  gelin orada satıcı adı ve api key bilgisine ulaşabilirsiniz.
                </Alert>
              </Grid>
            ) : null}
            {market.name == "Pazarama" ? (
              <Grid item xs={12}>
                <Alert
                  severity="info"
                  sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}
                >
                  Hesap bilgileri sayfasına gelin ve entegrasyon bilgileri
                  kısmında api key ve api secret bilgilerine ulaşabilirsiniz.
                </Alert>
              </Grid>
            ) : null}
            {market.name == "Pttavm" ? (
              <Grid item xs={12}>
                <Alert
                  severity="info"
                  sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}
                >
                  Mail adresinize gelen kullanıcı adı ve şifre bilgisi ile
                  entegre olabilrisiniz
                </Alert>
              </Grid>
            ) : null}
            {market.name == "Ozon" ? (
              <Grid item xs={12}>
                <Alert
                  severity="info"
                  sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}
                >
                  Ayarlar -> Satıcı Apisi sekmesinden Api Key(Anahtar) oluşturup
                  Client ID değerini öğrenebilirsiniz.
                </Alert>
              </Grid>
            ) : null}
            {market.name == "Etsy" ? (
              <>
              <Grid item xs={12}>
                <Alert
                  severity="info"
                  sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}
                >
                  <Box
                    component="ul"
                    sx={{ m: 0, pl: 2.5, "& li": { mb: 0.75 } }}
                  >
                    <Typography component="li" sx={{ fontSize: "inherit" }}>
                      <b>Api Key:</b> Etsy Developers (www.etsy.com/developers)
                      hesabınızda oluşturduğunuz uygulamanın "Keystring"
                      değeridir.
                    </Typography>
                    <Typography component="li" sx={{ fontSize: "inherit" }}>
                      <b>Shared Secret:</b> Aynı uygulama sayfasında Keystring'in
                      yanında, göz simgesine tıklayınca görünen ikinci
                      değerdir.
                    </Typography>
                    <Typography component="li" sx={{ fontSize: "inherit" }}>
                      <b>Shop ID:</b> Etsy mağaza panelinizin adres
                      çubuğundaki veya Shop Manager &gt; Ayarlar &gt; Bilgiler
                      bölümündeki mağaza numaranızdır.
                    </Typography>
                    <Typography component="li" sx={{ fontSize: "inherit" }}>
                      <b>Kargo Profili ID:</b> Shop Manager &gt; Ayarlar &gt;
                      Gönderim ayarları (Shipping settings) bölümünde
                      oluşturduğunuz kargo profilinin id'sidir.
                    </Typography>
                    <Typography component="li" sx={{ fontSize: "inherit" }}>
                      <b>İade Politikası ID:</b> Shop Manager &gt; Ayarlar
                      &gt; Politikalar (Policies) bölümündeki iade
                      politikanızın id'sidir.
                    </Typography>
                    <Typography component="li" sx={{ fontSize: "inherit" }}>
                      <b>İşleme Profili (Readiness State):</b> Etsy'nin
                      zorunlu tuttuğu işleme süresi profilidir. Etsy'e
                      bağlandıktan sonra mevcut profilleriniz otomatik
                      listelenir, yoksa aşağıdaki "Yeni işleme profili
                      oluştur" ile buradan yeni bir tane yaratabilirsiniz.
                    </Typography>
                    <Typography component="li" sx={{ fontSize: "inherit" }}>
                      <b>Kim Yaptı / Ne Zaman Yapıldı:</b> Ürünü siz mi,
                      başkası mı, bir grup mu ürettiği ve ne zaman
                      üretildiğidir; Etsy her ürün ilanında bu bilgiyi zorunlu
                      tutar.
                    </Typography>
                  </Box>
                </Alert>
              </Grid>
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    flexWrap: "wrap",
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={handleConnectEtsy}
                    disabled={etsyConnecting}
                    sx={{ textTransform: "none" }}
                  >
                    {etsyConnecting
                      ? "Bağlantı linki alınıyor..."
                      : isEtsyConnected
                      ? "Etsy Bağlantısını Yenile"
                      : "Etsy'e Bağlan"}
                  </Button>
                  <Typography
                    sx={{
                      fontSize: "0.875rem",
                      color: isEtsyConnected ? "success.main" : "text.secondary",
                      fontWeight: 500,
                    }}
                  >
                    {isEtsyConnected ? "Bağlı ✅" : "Bağlı değil"}
                  </Typography>
                </Box>
                {etsyConnectError ? (
                  <Alert severity="error" sx={{ mt: 1 }}>
                    {etsyConnectError}
                  </Alert>
                ) : null}
              </Grid>
              </>
            ) : null}
          </>
        )}
      </Grid>
    );
  };
  return (
    <form onSubmit={hasExistingData ? updateMarketAccount : addMarketAccount}>
      <Grid container spacing={{ xs: 1, sm: 2, md: 3 }}>
        <Grid item xs={12}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{ fontSize: { xs: "1.1rem", sm: "1.25rem", md: "1.5rem" } }}
          >
            {market.name} Ayarları
          </Typography>
        </Grid>
        {renderFields()}
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: { xs: "center", sm: "flex-end" },
            mt: { xs: 1, sm: 2, md: 3 },
            mb: { xs: 1, sm: 2 },
          }}
        >
          <Button
            type="submit"
            variant="contained"
            startIcon={<IoMdSave />}
            sx={{
              borderRadius: 2,
              backgroundColor: "#1F1B45",
              color: "#FFFFFF",
              textTransform: "none",
              fontWeight: 500,
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
              padding: { xs: "8px 16px", sm: "10px 20px" },
              display: "flex",
              alignItems: "center",
              gap: 1,
              width: { xs: "100%", sm: "auto" },
              "&:hover": {
                backgroundColor: "#2C285A",
              },
            }}
          >
            Kaydet
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

let i = 0;

const MarketPlacesAccount = () => {
  const {
    showSuccessMarketPlaceAccountAdd,
    showErrorAlertMarketPlaceAccountAdd,
  } = useAlert();
  const {
    showSuccessMarketPlaceAccountUpdate,
    showErrorAlertMarketPlaceAccountUpdate,
  } = useAlert();
  const authUserId = useSelector((state) => state?.auth?.user?.id);
  const [formErrors, setFormErrors] = useState([]);
  const [value, setValue] = useState(0);
  const [formValues, setFormValues] = useState([]);
  const [data, setData] = useState();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
  const getMarketPlace = async () => {
    try {
      const response = await dispatch(getMarketPlaces(token));

      if (response.success) {
        setFormValues(response?.data);
      }
    } catch (err) {
      console.log("Marketler getirilemedi", err);
    }
  };
  const getMarketpleaceAccounts = async () => {
    try {
      const response = await dispatch(
        getMarketPlacesAccounts(authUserId, token)
      );
      if (response.success) {
        setData(response?.data);
      }
    } catch (err) {
      console.log("Marketler hesap bilgileri getirilemedi", err);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await getMarketPlace();
      await getMarketpleaceAccounts();
      setLoading(false);
    };

    fetchData();
  }, []);
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: { xs: "200px", sm: "300px", md: "400px" },
        }}
      >
        <CircularProgress />
      </Box>
    );
  }
  if (formValues.length > 0) {
    return (
      <Box
        sx={{
          width: "100%",
          minHeight: { xs: "300px", sm: "400px", md: "500px" },
          height: "auto",
        }}
      >
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="marketplace tabs"
            sx={{
              "& .MuiTab-root": {
                fontSize: { xs: "0.75rem", sm: "0.875rem", md: "1rem" },
                minWidth: { xs: "80px", sm: "100px", md: "120px" },
              },
            }}
          >
            {formValues.map((market) => (
              <Tab
                key={market.id}
                label={market.name}
                id={`marketplace-tab-${market.id}`}
                aria-controls={`marketplace-tabpanel-${market.id}`}
              />
            ))}

            <Tab
              key={formValues.length}
              label={
                <span
                  style={{
                    fontSize: { xs: "24px", sm: "30px" },
                    fontWeight: "bold",
                  }}
                >
                  +
                </span>
              }
              id={`marketplace-tab-${formValues.length}`}
              aria-controls={`marketplace-tabpanel-${formValues.length}`}
            />
          </Tabs>
        </Box>
        {formValues.map((market, index) => (
          <TabPanel key={market.id} value={value} index={index}>
            <MarketplaceForm
              market={market}
              appUserId={authUserId}
              formErrors={formErrors}
              setFormErrors={setFormErrors}
              showSuccessMarketPlaceAccountAdd={
                showSuccessMarketPlaceAccountAdd
              }
              showErrorAlertMarketPlaceAccountAdd={
                showErrorAlertMarketPlaceAccountAdd
              }
              showSuccessMarketPlaceAccountUpdate={
                showSuccessMarketPlaceAccountUpdate
              }
              showErrorAlertMarketPlaceAccountUpdate={
                showErrorAlertMarketPlaceAccountUpdate
              }
              getMarketPlace={getMarketPlace}
              getMarketpleaceAccounts={getMarketpleaceAccounts}
              data={data}
              token={token}
              setLoading={setLoading}
            />
          </TabPanel>
        ))}

        <TabPanel
          key={formValues.length}
          value={value}
          index={formValues.length}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: { xs: 2, sm: 3, md: 4 },
            }}
          >
            <Alert
              severity="info"
              sx={{
                width: "100%",
                marginBottom: { xs: 2, sm: 3, md: 4 },
                fontSize: { xs: "0.875rem", sm: "1rem" },
              }}
            >
              Yeni bir pazaryeri eklemek için aşağıdaki butona
              tıklayabilirsiniz.
            </Alert>
            <Button
              variant="contained"
              startIcon={<FaPlus />}
              onClick={() => (window.location.href = "/Application")}
              sx={{
                width: { xs: "100%", sm: "auto" },
                fontSize: { xs: "0.875rem", sm: "1rem" },
                padding: { xs: "8px 16px", sm: "10px 20px" },
              }}
            >
              Ekle
            </Button>
          </Box>
        </TabPanel>
      </Box>
    );
  } else {
    return (
      <Box
        sx={{
          width: "100%",
          minHeight: { xs: "300px", sm: "400px", md: "500px" },
          height: "auto",
        }}
      >
        <TabPanel value={0} index={0}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: { xs: 2, sm: 3, md: 4 },
            }}
          >
            <Alert
              severity="info"
              sx={{
                width: "100%",
                marginBottom: { xs: 2, sm: 3, md: 4 },
                fontSize: { xs: "0.875rem", sm: "1rem" },
              }}
            >
              Henüz hiç pazaryeri eklenmemiş. Yeni bir pazaryeri eklemek için
              aşağıdaki butona tıklayabilirsiniz.
            </Alert>
            <Button
              variant="contained"
              startIcon={<FaPlus />}
              onClick={() => (window.location.href = "/Application")}
              sx={{
                width: { xs: "100%", sm: "auto" },
                fontSize: { xs: "0.875rem", sm: "1rem" },
                padding: { xs: "8px 16px", sm: "10px 20px" },
              }}
            >
              Yeni Pazaryeri Ekle
            </Button>
          </Box>
        </TabPanel>
      </Box>
    );
  }
};

export default MarketPlacesAccount;
